/** A file's size as people read it: `840 KB`, `2.1 MB`. */
export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return '1 KB'
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`
  const megabytes = bytes / (1024 * 1024)
  return `${megabytes < 10 ? megabytes.toFixed(1) : Math.round(megabytes)} MB`
}
